import { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('par_token');
    if (!token) { setLoading(false); return; }
    getMe()
      .then(res => setAgent(res.data))
      .catch(() => localStorage.removeItem('par_token'))
      .finally(() => setLoading(false));
  }, []);

  const signIn = (token, agentData) => {
    localStorage.setItem('par_token', token);
    setAgent(agentData);
  };

  const signOut = () => {
    localStorage.removeItem('par_token');
    setAgent(null);
  };

  const refreshAgent = () =>
    getMe().then(res => setAgent(res.data));

  return (
    <AuthContext.Provider value={{ agent, loading, signIn, signOut, refreshAgent }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
